
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
import MenuCreateCombo from "../menu/menu-create-combo.vue";

export default {
  components: {
    ResponsiveDialog,
    MenuCreateCombo
  },
  props: {
    dialog: Boolean,
    comboProp: {
      default: () => {}
    }
  }
};
